import React from "react";
import {
  DashboardHeader,
  Meditation,
  Overview,
  StartNow,
  TopCoins,
  WhyComplend,
} from "./components";
import { Footer } from "../../layouts/Footer/Footer";

import "./Landing.css";
import Faq from "./components/Faq/Faq";
import Roadmap from "./components/Roadmap/Roadmap";

export const Landing = ({
  handleGetStarted,
  handleConnect,
  account,
  startTrade,
  allImages,
  info,
  whyComplendData,
  overviewProjectsData,
  animate,
  helpSupportClick,
}) => {
  return (
    <div className="dashboard-overflow scroll">
      <main className="dashboard-main">
        <DashboardHeader
          animate={animate}
          handleGetStarted={handleGetStarted}
          handleConnect={handleConnect}
          account={account}
          dashboardHeaderImages={allImages?.dashboardHeader}
        />
        <Overview data={overviewProjectsData} />
        <TopCoins
          startTrade={startTrade}
          topCoinsImages={allImages?.topcoins}
        />
        {/* <Meditation meditationImages={allImages?.meditation} info={info} /> */}
        <Roadmap />
        <Faq />
        <WhyComplend data={whyComplendData} images={allImages?.whyComplend} />
        <StartNow
          handleConnect={handleConnect}
          account={account}
          startNowImages={allImages?.startNow}
        />
        {/* <Footer helpSupportClick={helpSupportClick} /> */}
      </main>
    </div>
  );
};
